import { useEffect, useRef, useState } from 'react';

const STARTERS = [
  '何から始めればいいか分からない',
  '会社を辞めるタイミングを迷っている',
  '資金がいくら必要か分からない',
  '個人事業主か法人か決められない',
  'お客さんが取れない',
];

export function Composer({
  onSend,
  disabled,
  showStarters,
}: {
  onSend: (text: string) => void;
  disabled: boolean;
  showStarters: boolean;
}) {
  const [value, setValue] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // 入力量に応じて高さを合わせる（最大値は CSS 側で止める）
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  const submit = () => {
    const text = value.trim();
    if (!text || disabled) return;
    onSend(text);
    setValue('');
  };

  return (
    <div className="composer">
      <div className="composer__inner">
        {showStarters && (
          <div className="prompts">
            {STARTERS.map((starter) => (
              <button
                key={starter}
                type="button"
                className="chip"
                disabled={disabled}
                onClick={() => onSend(starter)}
              >
                {starter}
              </button>
            ))}
          </div>
        )}

        <div className="composer__row">
          <label className="visually-hidden" htmlFor="composer-input">
            相談内容
          </label>
          <textarea
            id="composer-input"
            ref={textareaRef}
            rows={1}
            value={value}
            placeholder="いま気になっていることを、そのまま書いてください"
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              // 日本語入力の変換確定を送信と誤認しない
              if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent.isComposing) {
                e.preventDefault();
                submit();
              }
            }}
          />
          <button type="button" className="send" onClick={submit} disabled={disabled || !value.trim()}>
            送る
          </button>
        </div>

        <p className="composer__note">
          Enter で送信、Shift+Enter で改行。おじさんの話は参考意見です。税務・法務・融資の判断は必ず専門家と公式情報で確認してください。紹介するサービスには広告（アフィリエイト）を含みます。
        </p>
      </div>
    </div>
  );
}
